import {observer} from "mobx-react";
import {useStore} from "../../../../../../../hooks";
import {
  ModalActionsWrapper,
  ModalBox,
  ModalContentWrapper,
  ModalWrapper
} from "../../../../../../../elements/v2/modals/Modals.styled";
import {Title} from "../../../../../../../elements/v2/modals/ConfirmationModal.styled";
import {Subtitle} from "../../Marketing.styled";
import {RoundedButton} from "../../../../../../../elements";
import React from "react";

export const CampaignScheduleModal = observer(() => {
  const { marketingStore } = useStore();
  const { modal, currentCampaign } = marketingStore;

  const formatter = new Intl.DateTimeFormat("en-US", {
    month: "long",
    day: "numeric",
    year: "numeric",
  });

  const timeFormatter = new Intl.DateTimeFormat("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });

  return (
    <ModalWrapper $isOpen={modal.campaignSchedule}>
      <ModalBox width="500px" height="305px">
        <ModalContentWrapper>
          <Title>Schedule Adjustment Notice</Title>
          <p>We've adjusted your campaign schedule to ensure timely delivery. Please review the details below and confirm or make changes before publishing.</p>
          <div><Subtitle>Campaign Title:</Subtitle> {currentCampaign?.name}</div>
          <div><Subtitle>Start Date & Time:</Subtitle> {`${formatter.format(currentCampaign?.startDate)} at ${timeFormatter.format(currentCampaign?.startDate)}`}</div>
          <div><Subtitle>End Date & Time:</Subtitle> {`${formatter.format(currentCampaign?.endDate)} at ${timeFormatter.format(currentCampaign?.endDate)}`}</div>
        </ModalContentWrapper>
        <ModalActionsWrapper>
          <RoundedButton onClick={() => modal.onConfirm("campaignSchedule")} kind={"blue"}>Confirm & Publish</RoundedButton>
          <RoundedButton onClick={() => modal.onCancel("campaignSchedule")} kind={"primary"}>Edit Schedule</RoundedButton>
        </ModalActionsWrapper>
      </ModalBox>
    </ModalWrapper>
  );
});
